import { LoyaltyTierKey } from 'generated/graphql-gateway';
import { selectors, useAppSelector } from 'state/global-state';

export const useLoyaltyUserTier = (): {
  loyaltyTierKey: LoyaltyTierKey;
  loyaltyTierExpiryDate: string | undefined;
} => {
  const userDetails = useAppSelector(selectors.loyalty.selectLoyaltyUser);

  return {
    loyaltyTierKey: userDetails.loyaltyUser?.loyaltyTier?.loyaltyTierKey ?? LoyaltyTierKey.TIER_1,
    loyaltyTierExpiryDate: userDetails.loyaltyUser?.loyaltyTier?.loyaltyTierExpiryDate,
  };
};
